import {KeypadControlsView} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsView';
import {KeypadControlsViewMobile} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsViewMobile';
import {KeypadControlsModule} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsModule';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot/modules/genericPopup';
import {AutoplayEvents} from '@gongxigames/framework/slot/modules/autoplay';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';

type View = KeypadControlsView | KeypadControlsViewMobile;

// @ts-ignore
// TODO: refactor required
export class KeypadControlsDuringAutoplayGameState extends ModuleState<View, KeypadControlsModule> {
    protected autoplayButtons = ['autoplay', 'info', 'bet', 'home', 'menu', 'totalBetOpenButton'];

    public onEnterState(): void {
        this.autoplayButtons.forEach(btn => {
            this.module.disableByName(btn, UIDisableReason.AUTOPLAY_MODE);
        });
    }

    public onLeaveState(): void {
        this.autoplayButtons.forEach(btn => {
            this.module.enableByName(btn, UIDisableReason.AUTOPLAY_MODE);
        });
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted.bind(this));
        this.setEventHandler(GenericPopupEvents.INTRO_STARTED, this.onPopupStarted.bind(this));
        this.setEventHandler(AutoplayEvents.STOP_AUTOPLAY, this.onAutoplayStopped.bind(this));
    }

    protected onPopupStarted(type: symbol): void {
        if (type === GenericPopupType.FREESPIN_INTRO) {
            this.onFreeSpinsIntro();
        }
    }

    protected onFreeSpinsIntro(): void {
        this.module.gotoState(KeypadControlsModule.FREESPINS_AUTOPLAY_STATE);
    }

    protected onReelsSpinningStarted(): void {
        this.module.disableAll(UIDisableReason.SPINNING);
    }

    protected onAutoplayStopped(): void {
        this.module.gotoState(KeypadControlsModule.BASIC_STATE);
    }
}
